import React from 'react';
import Aside from './Aside';
import { Route, Switch } from 'react-router-dom';
import Dashboard from './../DashBoard/main';
import Settings from './../Settings/main.js'
import Racuni from './../Racuni/main.js'
import TopBar from './TopBar'
import Izvjestaji from './../Izvjestaji/main.js'
import PRedlozakRacuna from './../Settings/RacunPredlozakTinyMCE.js'

function Layout({ setLocale }) {
	
	return (
		<>
			<TopBar />
			<div className="app">
				<Aside/>
				<Switch>
					{/* redirect to dashboard after login */}
					
					<Route exact path="/Client/dashboard">
						<Dashboard />
					</Route>
					<Route path="/Client/racuni">
						<Racuni />
					</Route>         
					<Route exact path="/Client/settings">
						<Settings/>
					</Route> 
					<Route exact path="/Client/izvjestaji">
						<Izvjestaji />
					</Route>  

                    <Route exact path="/Client/settings/predlozakRacuna">
						<PRedlozakRacuna />
					</Route>         
				</Switch>
			</div>
		</>
	);
}

export default Layout;
